<style scoped>
@media only screen and (max-width: 992px) {
  table tr td *,
  table tr th {
    font-size: 0.8em;
  }
}
</style>
<template lang='pug'>
    .main-content-padded.main-content-nopad-small
      .input-field
        input#search.autocomplete(type='text', ref='places', placeholder='Search places', v-model='searchPlaces')
        label.active(for='search') Search Place
</template>
<script>
/* eslint-disable no-undef */
import axios from 'axios'
import debounce from 'debounce'

export default {
  meta: {
    title: 'Orders'
  },
  data () {
    return {
      predictedPlaces: {},
      searchPlaces: null,
      placesAutocomplete: null,
      searchListener: null
    }
  },
  mounted () {
    this.searchListener = debounce(this.searchOrder, 1000)
    const search = document.getElementById('search')
    search.addEventListener('keyup', this.searchListener)

    this.placesAutocomplete = this.$M.Autocomplete.init(document.getElementById('search'), {
      data: this.predictedPlaces
    })
  },
  methods: {
    searchOrder () {
      return this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        return axios
          .get(`${this.$config.API_URL}/config/places`, {
            headers: {
              authorization: `Bearer ${accessToken}`
            },
            params: {
              place: this.searchPlaces
            }
          })
          .then(result => {
            if (result) {
              this.predictedPlaces = {}

              for (let i = 0; i < result.data.length; i++) {
                this.predictedPlaces[result.data[i].description] = null
              }

              this.placesAutocomplete.updateData(this.predictedPlaces)
              this.placesAutocomplete.open()
            }
          })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/page-assign-places.vue